<template>

  <v-dialog v-model="dialog" max-width="1000px">
    <template v-slot:activator="{ on }">
      <v-btn color="blue darken-1" text v-on="on" :disabled="!template_id">Preview</v-btn>
    </template>
    <v-card v-if="dialog">
      <v-card-text class="pb-0">
        <v-container>

          <v-select
            v-model="from"
            :items="fromList"
            label="From"
            item-text="from"
            return-object
            hide-details
          ></v-select>

          <v-text-field
            v-model="template.subject"
            label="Subject"
            :rules="[v => !!v || 'Subject is required']"
            required
            hide-details
          ></v-text-field>

          <v-text-field
            v-model="template.explain"
            label="Explain"
            hide-details
          ></v-text-field>

          <tiny-mce
            class="mt-3"
            v-if="template.content"
            :id="'mail-template-preview-' + (template.template_id || Date.now())"
            :other_options="config"
            v-model="template.content"
          />
        </v-container>
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="send" :loading="sending">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
  import { isEmpty } from 'lodash'

  import '@/assets/css/tinymce-vue.css'
  import TinyMce from 'tinymce-vue'

  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'

  export default {

    props: [ 'from', 'fromList', 'language', 'template_id', 'variables', 'closeParent' ],

    components: {
      TinyMce
    },

    data: () => ({
      dialog: false,
      template: {
        content: null
      },
      sending: false,
      loadingTemplate: false,
      config: {
        height: 450,
        inline: false,
        theme: 'modern',
        fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 34px 38px 42px 48px 54px 60px',
        plugins: [ 'code fullpage visualchars image link media table  hr nonbreaking anchor toc lists textcolor wordcount imagetools contextmenu colorpicker textpattern' ],
        toolbar1: 'formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
        menubar: false,
        image_advtab: true
      },
      valid: false,
    }),

    watch: {
      dialog (val) {
        this.$nextTick(() => {
          this.template = {
            content: '<p></p>'
          }
        })

        if (val) {
          this.loadMailTemplate(this.template_id)
        }
      }
    },

    methods: {

      isEmpty: (o) => isEmpty(o),

      send () {
        this.sending = true
        API.call('/mail/send.json', {
          template_id: this.template_id,
          from: this.from.mail_settings_id,
          login: this.active.account.login,
          subject: this.template.subject,
          explain: this.template.explain,
          content: this.template.content,
          account_id: this.active.account_id
        }, this.active.account).then(resp => {
          this.dialog = false
          this.closeParent()

          this.$notification.show = true
          this.$notification.message = resp.data.join('<br />')
          this.$notification.type = 'success'
        }).then(() => {
          this.$store.dispatch('account/loadComments', { account: this.active.account, type: 'communication' })
        }).catch(e => {
        }).finally(() => {
          this.sending = false
        })
      },
      loadMailTemplate (template_id) {
        this.loadingTemplate = true
        API.call('/mail/template/item.json', {
          template_id: template_id,
          language: this.language,
        }, this.active.account).then(resp => {
          this.template = resp.data
          this.template.subject = this.replaceVariables(this.template.translation[0].subject)
          this.template.content = this.replaceVariables(this.template.translation[0].content)
        }).catch(e => {
        }).finally(() => {
          this.loadingTemplate = false
        })
      },

      replaceVariables (text) {

        let variables = (text.match(/({{.*?}})/g) || []).map((v) => v.replace(/{|}/g, ''))

        for (let v of variables) {
          let variable = '{{' + v + '}}'

          let parts = v.split('|')

          if (parts.length > 1) {
            for (let nv of parts) {
              if (this.variables[nv]) {
                v = nv //get first value from {{Var1|Var2}}
                break
              }
            }
          }

          text = text.replace(variable, (this.variables[v] || ''))
        }

        return text
      }
    },

    computed: {
      ...mapGetters({ active: 'account/active' }),
    },

  }
</script>
